import React, { Component } from 'react';
import Modal from 'react-responsive-modal';

export default class Signuppopup extends Component {
    constructor(props)
    {
        super(props);
        this.state = {
            open: false,
        }
    }
    Open()
    {
        this.setState({
            open: true
        });
    }
    Close()
    {
        this.setState({
            open: false
        }, this.moveBack);
    }
    moveBack()
    {
        window.location.href = '/Login';
    }
    render()
    {
        const self = this;
        return(
        <Modal open={this.state.open} onClose={()=>{self.Close()}} center>
            <div className="modal-dialog modal-md mb0">
                <div className="popupPadding pr45">
                    <div className="md-popup-header"> &nbsp;회원 가입</div>
                    <div className="row pl15 pr15"></div>
                    <div className="md-popup-contents pt0 pl0 text-center">
                        <div className="pt15 pb15">
                            <i className="icon fa fa-check font30"></i>
                        </div>
                        <h6 className="font16"><b>회원 가입 신청이 완료 되었습니다. 신청완료 후 로그인 가능합니다!</b></h6>                        
                    </div>
                </div>
            </div>
        </Modal>
        );
    }
}